import { styled } from '@mui/material/styles';
import { Checkbox, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import React from 'react';
import { useTheme } from '@mui/material/styles';

const PREFIX = 'PolicyForRegForm';

const classes = {
  policy: `${PREFIX}-policy`,
  policyCheckbox: `${PREFIX}-policyCheckbox`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.policy}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.policyCheckbox}`]: {
    marginTop: '14px',
  },
}));

export const PolicyForRegForm = props => {
  const theme = useTheme();

  return (
    <Root className={classes.policy}>
      <Checkbox
        checked={props.value || false}
        className={classes.policyCheckbox}
        color='primary'
        name='policy'
        onChange={props.onChange}
        required={true}
      />
      <Typography style={{ marginTop: theme.spacing(2) }} color='textSecondary' variant='body1'>
        Я принимаю&nbsp;
        <Link
          color='primary'
          href='/privacy-policy.pdf'
          underline='always'
          variant='h6'
          target={'_blank'}
        >
          Политику конфиденциальности
        </Link>
        .
      </Typography>
    </Root>
  );
};
